const Address = require('./Address');
const AgeGroup = require('./AgeGroup');
const CenterQuestion = require('./CenterQuestion');
const Classroom = require('./Classroom');
const Priority = require('./Priority');
const Schedule = require('./Schedule');

class Center {
  constructor() {
    this.init();
  }

  init() {
    this.center_id = undefined;
    this.provider_id = undefined;
    this.provider_name = undefined;
    this.name = '';
    this.type = undefined;
    this.relationship = undefined;
    this.onboarded = undefined;
    this.status = undefined;
    this.contact = undefined;
    this.contact_image_url = undefined;
    this.email = undefined;
    this.phone_number = undefined;
    this.public_email = undefined;
    this.public_phone_number = undefined;
    this.ageGroups = undefined;
    this.classrooms = undefined;
    this.subsidies = undefined;
    this.priorities = undefined;
    this.external_website = undefined;
    this.license = undefined;
    this.license_url = undefined;
    this.license_expiration = undefined;
    this.licensed_capacity = undefined;
    this.license_exempt = undefined;
    this.tour_policy = undefined;
    this.custom_questions = undefined;
    this.latitude = undefined;
    this.longitude = undefined;
    this.timezone = undefined;
    this.county = undefined;
    this.turnaround_time = undefined;
    this.display_options = undefined;
    this.address = new Address();
    this.schedule = new Schedule();
    this.social_links = undefined

    // Derived from provider
    this.handbook_url = undefined;
    this.safety_guidelines_url = undefined;
    this.logo_url = undefined;
  }

  copy() {
    const cp = new Center();

    cp.center_id = this.center_id;
    cp.provider_id = this.provider_id;
    cp.provider_name = this.provider_name;
    cp.name = this.name;
    cp.type = this.type;
    cp.relationship = this.relationship;
    cp.onboarded = this.onboarded ? new Date(this.onboarded) : undefined;
    cp.status = this.status;
    cp.contact = this.contact;
    cp.contact_image_url = this.contact_image_url;
    cp.email = this.email;
    cp.phone_number = this.phone_number;
    cp.public_email = this.email;
    cp.public_phone_number = this.public_phone_number;
    cp.public_phone_number_can_text = this.public_phone_number_can_text;
    cp.secondary_public_phone_number = this.secondary_public_phone_number;
    cp.secondary_public_phone_number_can_text = this.secondary_public_phone_number_can_text;
    cp.handbook_url = this.handbook_url;
    cp.safety_guidelines_url = this.safety_guidelines_url;
    cp.logo_url = this.logo_url;
    cp.external_website = this.external_website;
    cp.license = this.license;
    cp.license_url = this.license_url;
    cp.license_expiration = this.license_expiration ? new Date(this.license_expiration) : undefined;
    cp.licensed_capacity = this.licensed_capacity;
    cp.license_exempt = this.license_exempt;
    cp.tour_policy = this.tour_policy ? Object.assign({}, this.tour_policy) : undefined;
    cp.turnaround_time = this.turnaround_time;
    cp.display_options = this.display_options ? Object.assign({}, this.display_options) : undefined;
    cp.subsidies = this.subsidies ? [].concat(this.subsidies) : undefined;
    cp.social_links = this.social_links ? Object.assign({}, this.social_links) : undefined;

    if (this.ageGroups) {
      cp.ageGroups = [];
      this.ageGroups.forEach((w) => {
        cp.ageGroups.push(w.copy());
      });
    }
    if (this.classrooms) {
      cp.classrooms = [];
      this.classrooms.forEach((c) => {
        cp.classrooms.push(c.copy());
      });
    }
    if (this.priorities) {
      cp.priorities = [];
      this.priorities.forEach((p) => {
        cp.priorities.push(p.copy());
      });
    }
    if (this.custom_questions) {
      cp.custom_questions = [];
      this.custom_questions.forEach((q) => {
        cp.custom_questions.push(q.copy());
      });
    }

    cp.latitude = this.latitude;
    cp.longitude = this.longitude;
    cp.timezone = this.timezone;
    cp.county = this.county;
    cp.address = this.address.copy();
    cp.schedule = this.schedule.copy();
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.provider_name = obj.provider_name ? obj.provider_name : undefined;
      this.name = obj.name ? obj.name : '';
      this.type = obj.type ? obj.type : undefined;
      this.relationship = obj.relationship ? obj.relationship : undefined;
      this.onboarded = obj.onboarded ? new Date(obj.onboarded) : undefined;
      this.status = obj.status ? obj.status : undefined;
      this.contact = obj.contact ? obj.contact : undefined;
      this.contact_image_url = obj.contact_image_url ? obj.contact_image_url : undefined;
      this.email = obj.email ? obj.email : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.public_email = obj.public_email ? obj.public_email : undefined;
      this.public_phone_number = obj.public_phone_number ? obj.public_phone_number : undefined;
      this.public_phone_number_can_text = obj.public_phone_number_can_text ? obj.public_phone_number_can_text : undefined;
      this.secondary_public_phone_number = obj.secondary_public_phone_number ? obj.secondary_public_phone_number : undefined;
      this.secondary_public_phone_number_can_text = obj.secondary_public_phone_number_can_text ? obj.secondary_public_phone_number_can_text : undefined;
      this.handbook_url = obj.handbook_url ? obj.handbook_url : undefined;
      this.safety_guidelines_url = obj.safety_guidelines_url ? obj.safety_guidelines_url : undefined;
      this.logo_url = obj.logo_url ? obj.logo_url : undefined;
      this.external_website = obj.external_website ? obj.external_website : undefined;
      this.license = obj.license ? obj.license : undefined;
      this.license_url = obj.license_url ? obj.license_url : undefined;
      this.license_expiration = obj.license_expiration ? new Date(obj.license_expiration) : undefined;
      this.licensed_capacity = obj.licensed_capacity ? obj.licensed_capacity : undefined;
      this.license_exempt = obj.license_exempt ? obj.license_exempt : false;
      this.tour_policy = obj.tour_policy ? Object.assign({}, obj.tour_policy) : undefined;
      this.latitude = obj.latitude ? obj.latitude : undefined;
      this.longitude = obj.longitude ? obj.longitude : undefined;
      this.timezone = obj.timezone ? obj.timezone : undefined;
      this.county = obj.county ? obj.county : undefined;
      this.turnaround_time = obj.turnaround_time ? obj.turnaround_time : undefined;
      this.display_options = obj.display_options ? Object.assign({}, obj.display_options) : undefined;
      this.subsidies = obj.subsidies ? [].concat(obj.subsidies) : undefined;
      this.social_links = obj.social_links ? Object.assign({}, obj.social_links) : undefined;

      this.address.buildFromJSON(obj.address ? obj.address : {});
      this.schedule.buildFromJSON(obj.schedule);

      if (obj.ageGroups) {
        this.ageGroups = [];
        obj.ageGroups.forEach((c) => {
          const ageGroup = new AgeGroup();
          ageGroup.buildFromJSON(c);
          this.ageGroups.push(ageGroup);
        });
      }
      if (obj.classrooms) {
        this.classrooms = [];
        obj.classrooms.forEach((c) => {
          const classroom = new Classroom();
          classroom.buildFromJSON(c);
          this.classrooms.push(classroom);
        });
      }
      if (obj.priorities) {
        this.priorities = [];
        obj.priorities.forEach((p) => {
          const priority = new Priority();
          priority.buildFromJSON(p);
          this.priorities.push(priority);
        });
      }
      if (obj.custom_questions) {
        this.custom_questions = [];
        obj.custom_questions.forEach((q) => {
          const question = new CenterQuestion();
          question.buildFromJSON(q);
          this.custom_questions.push(question);
        });
      }
    }
  }

  toString() {
    let result = this.name;
    const address = this.address.toString();

    if (this.center_id) {
      result = (result.length) ? `${result} (Center: ${this.center_id})` : `${this.center_id}`;
    }
    if (this.provider_name || this.provider_id) {
      const pname = this.provider_name || this.provider_id;
      result = (result.length) ? `${result} (Provider: ${pname})` : `${pname}`;
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.center_id;
  }

  setId(center_id) {
    this.center_id = center_id ? center_id.toString() : undefined;
  }

  getProviderId() {
    return this.provider_id;
  }

  setProviderId(provider_id) {
    this.provider_id = provider_id ? provider_id.toString() : undefined;
  }

  getProviderName() {
    return this.provider_name;
  }

  setProviderName(name) {
    this.provider_name = name;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getType() {
    return this.type;
  }

  setType(type) {
    this.type = type;
  }

  getRelationship() {
    return this.relationship;
  }

  setRelationship(relationship) {
    this.relationship = relationship;
  }

  getOnboarded() {
    return this.onboarded;
  }

  setOnboarded(onboarded) {
    this.onboarded = onboarded ? new Date(onboarded) : undefined;
  }

  getStatus() {
    return this.status;
  }

  setStatus(status) {
    this.status = status;
  }

  getContactName() {
    return this.contact;
  }

  setContactName(contact) {
    this.contact = contact;
  }

  getContactImageUrl() {
    return this.contact_image_url;
  }

  setContactImageUrl(url) {
    this.contact_image_url = url;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }

  getPublicEmail() {
    return this.public_email;
  }

  setPublicEmail(public_email) {
    this.public_email = public_email;
  }

  getPublicPhoneNumber() {
    return this.public_phone_number;
  }

  setPublicPhoneNumber(public_phone_number) {
    this.public_phone_number = public_phone_number;
  }

  getPublicPhoneNumberCanText() {
    return this.public_phone_number_can_text;
  }

  setPublicPhoneNumberCanText(can_text) {
    this.public_phone_number_can_text = can_text;
  }

  getSecondaryPublicPhoneNumber() {
    return this.secondary_public_phone_number;
  }

  setSecondaryPublicPhoneNumber(secondary_public_phone_number) {
    this.secondary_public_phone_number = secondary_public_phone_number;
  }

  getSecondaryPublicPhoneNumberCanText() {
    return this.secondary_public_phone_number_can_text;
  }

  setSecondaryPublicPhoneNumberCanText(can_text) {
    this.secondary_public_phone_number_can_text = can_text;
  }

  getExternalWebsite() {
    return this.external_website;
  }

  setExternalWebsite(external_website) {
    this.external_website = external_website;
  }

  getLicense() {
    return this.license;
  }

  setLicense(license) {
    this.license = license;
  }

  getLicenseUrl() {
    return this.license_url;
  }

  setLicenseUrl(license_url) {
    this.license_url = license_url;
  }

  getLicenseExpiration() {
    return this.license_expiration;
  }

  setLicenseExpiration(license_expiration) {
    this.license_expiration = license_expiration ? new Date(license_expiration) : undefined;
  }

  getLicensedCapacity() {
    return this.licensed_capacity;
  }

  setLicensedCapacity(licensed_capacity) {
    this.licensed_capacity = licensed_capacity;
  }

  getLicenseExempt() {
    return this.license_exempt;
  }

  setLicenseExempt(license_exempt) {
    this.license_exempt = license_exempt;
  }

  getTourPolicy() {
    return this.tour_policy;
  }

  setTourPolicy(tour_policy) {
    this.tour_policy = tour_policy ? Object.assign({}, tour_policy) : undefined;
  }

  getLatitude() {
    return this.latitude;
  }

  setLatitude(latitude) {
    this.latitude = latitude;
  }

  getLongitude() {
    return this.longitude;
  }

  setLongitude(longitude) {
    this.longitude = longitude;
  }

  getTimezone() {
    return this.timezone;
  }

  setTimezone(timezone) {
    this.timezone = timezone;
  }

  getCounty() {
    return this.county;
  }

  setCounty(county) {
    this.county = county;
  }

  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getSubsidies() {
    return this.subsidies || [];
  }

  setSubsidies(subsidies) {
    this.subsidies = subsidies ? [].concat(subsidies) : undefined;
  }

  getAgeGroups() {
    return this.ageGroups;
  }

  setAgeGroups(ageGroups) {
    if (ageGroups) {
      this.ageGroups = [];
      ageGroups.forEach((w) => {
        this.ageGroups.push(w.copy());
      });
    } else {
      this.ageGroups = undefined;
    }
  }

  getClassrooms() {
    return this.classrooms;
  }

  setClassrooms(classrooms) {
    this.classrooms = undefined;
    if (classrooms) {
      this.classrooms = [];
      classrooms.forEach((c) => {
        this.classrooms.push(c.copy());
      });
    }
  }

  getSchedule() {
    return this.schedule;
  }

  setSchedule(schedule) {
    this.schedule = schedule;
  }

  getPriorities() {
    return this.priorities;
  }

  setPriorities(priorities) {
    if (priorities) {
      this.priorities = [];
      priorities.forEach((p) => {
        this.priorities.push(p.copy());
      });
    } else {
      this.prioities = undefined;
    }
  }

  getCustomQuestions() {
    return this.custom_questions;
  }

  setCustomQuestions(custom_questions) {
    this.custom_questions = undefined;
    if (custom_questions) {
      this.custom_questions = [];
      custom_questions.forEach((q) => {
        this.custom_questions.push(q.copy());
      });
    }
  }

  getTurnaroundTime() {
    return this.turnaround_time;
  }

  setTurnaroundTime(turnaround_time) {
    this.turnaround_time = turnaround_time;
  }

  getDisplayOptions() {
    return this.display_options;
  }

  setDisplayOptions(options) {
    this.display_options = options;
  }

  // Derived (read only)
  getHandbookUrl() {
    return this.handbook_url;
  }

  getSafetyGuidelinesUrl() {
    return this.safety_guidelines_url;
  }

  getLogoUrl() {
    return this.logo_url;
  }

  getSocialLinks() {
    return this.social_links;
  }

  setSocialLinks(social_links) {
    this.social_links = social_links ? Object.assign({}, social_links) : undefined;
  }
}

module.exports = Center;
